<template>
  <div class="home-container container-fluid py-3 ">
    <div class="row justify-content-start">
      <div class="col flex-grow-1" >
        <img class="ais-logo" :src="require('/src/assets/img/ais-logo.png')" alt="">
      </div>
<!--      <div class="col flex-grow-0" >-->
<!--        <img class="ais-banner" style="width: 44px;" :src="require('/src/assets/img/banner.png')" alt="">-->
<!--      </div>-->
    </div>
    <div class="row justify-content-center">
      <div class="mt-3 col-lg-8 col-xl-7"
           :class="{'col-12': !isMobile, 'col-8': screenMode === 'landscape' && isMobile}">
        <vimmi-player ref="player" v-if="activeChannel" class="main-player "
                      :active-channel="activeChannel" @on-loaded="redesign"></vimmi-player>
      </div>
      <div class="col-12 col-lg-4 epg-wrap mt-3">
        <epg-list v-if="activeChannel" :show-only-active="onlyActiveEpg" :max-height="epgHeight"
                  :active-channel="activeChannel"></epg-list>
      </div>
    </div>
    <div v-if="mode === 'full'" class="row">
      <div class="col-12 col-md-12 col-xl-11  pt-4 pt-md-2 m-auto">
        <div class="channels-title ">

          {{ tText('channels') }}
        </div>
        <div class="channels-list mt-3 pb-1 w-100">
          <div class="channel-item  text-start" :class="{'active':channel === activeChannel}"
               v-for="(channel, cId) in channels" @click="selectChannel(channel)">
            <div class="position-relative poster-wrap">
              <div class="aspect-ratio-box ar-1">
                <div class="aspect-ratio-box-inside">
                  <img class="channel-poster" :title="t(channel, 'title')" :src="channel.poster" alt="">
                </div>
              </div>
              <!--              <vimmi-player :aspect-ratio="true" :active-channel="channel"></vimmi-player>-->
              <!--              <span class="channel-item-title">{{ channel.title }}</span>-->
            </div>
            <div class="channel-item-title" :title="t(channel, 'title')">{{ t(channel, 'title') }}</div>
            <!--            <span class="channel-item-epg pt-2">{{ channel.epg.length ? getActiveEpg(channel.epg)?.title : '' }}</span>-->
          </div>
          <div class="spacer"></div>

          <div class="channel-item exclusive active text-start">
            <a target="_top" :href="exclusiveBanner.link">
              <div class="position-relative poster-wrap">
                <div class="aspect-ratio-box ar-1">
                  <div class="aspect-ratio-box-inside">
                    <img class="channel-poster" :src="exclusiveBanner.backdrop" alt="">
                  </div>
                </div>
              </div>
              <div class="channel-item-title">{{ tText('exclusive_for_ais') }}</div>
            </a>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>

  import VimmiPlayer from "../components/vimmi-player/vimmi-player";
  import EpgList from "../components/epg-list/epg-list";
  import Config from "../service/config";
  import {normDomain} from "vimmi-web-utils/cjs/normDomain";
  import epgSrv from "../service/epg";
  import {screenMode} from "vimmi-web-utils/cjs/screenMode";
  import {device} from "vimmi-web-utils/cjs/device";
  import {contentTranslate} from "../mixin/translate.js";
  import channelsSrv from "../service/channels.js";

  export default {
    name: 'Home',
    components: {EpgList, VimmiPlayer},
    mixins: [contentTranslate],
    data() {
      return {
        // isLoading: true,
        mode: null,
        onlyActiveEpg: false,
        screenMode: screenMode(),
        isMobile: device.isAnyMobile(),
        epgHeight: 300,
        activeChannel: null,
        exclusiveBanner: {
          backdrop: 'https://ais-s.demo-vidnt.com/ais/play/origin/VOD/Poster/exclusive.backdrop.original.jpg',
          link: 'https://aisplay.ais.co.th/portal/get_section/611f146e677d560953a09387/',
        },
        channels: {}
      }
    },
    mounted() {
      this.init();
      window.addEventListener('orientationchange', () => {
        setTimeout(() => {
          this.screenMode = screenMode();
          this.isMobile = device.isAnyMobile();
        }, 200)
      })
    },
    computed: {},
    methods: {
      redirectTo(link) {
        window.open(link, '_blank');
      },
      async init() {

        this.mode = this.$route.query.t === 'player' ? 'player' : 'full';
        this.language = this.$route.query.l ? ['eng', 'tha'].indexOf(this.$route.query.l) !== -1 ? this.$route.query.l : 'tha' : 'tha';

        Config.set('env', location.href.indexOf('localhost') !== -1 ? 'stg' : location.href.indexOf('ais-stg-olympic') !== -1 ? 'stg' : 'prod');
        Config.set('backend', this.$route.query.backend ? normDomain(this.$route.query.backend) : Config.get('env') === 'stg' ? 'ais-stg-app.demo-vidnt.com' : 'aisplay.ais.co.th');
        Config.set('mode', this.mode);
        Config.set('language', this.language);
        Config.set('target_site', this.$route.query.target_site ? decodeURIComponent(this.$route.query.target_site) : null);


        window.addEventListener('resize', this.debounce(() => {
          this.redesign()
        }, 101));
        window.addEventListener('load', this.debounce(() => {

          this.redesign()

          // this.$nextTick(() => {
          //   this.isLoading = false;
          // })
        }, 100));
        this.channels = await channelsSrv.getChannels();
        //
        // this.channels = await doFetch(`/${Config.get('env')}-channels.json`);


        await this.loadEpg();

        if (this.$route.query.ch && this.channels[this.$route.query.ch]) {
          this.activeChannel = this.channels[this.$route.query.ch];
        }
      },
      redesign() {
        if (this.activeChannel) {
          if (this.$refs.player.getPlayerHeight()) {
            this.epgHeight = this.$refs.player.getPlayerHeight();
          }
        }
        this.onlyActiveEpg = window.innerWidth < 900
      },
      selectChannel(channel) {
        this.activeChannel = channel;
        this.$nextTick(() => {
          setTimeout(() => {
            this.redesign()
          }, 100);
        })
      },
      async loadEpg() {
        let epgList = await epgSrv.getByChannels(Object.keys(this.channels));
        epgList.map((item) => {
          if (item.parent && this.channels[item.parent] && this.channels[item.parent].epgList) {
            this.channels[item.parent].epgList.push(item);
          }
        });
        return true;
      },
      debounce(fn, delay) {
        let timeoutID = null;
        let that = this
        return function () {
          clearTimeout(timeoutID)
          let args = arguments
          // let that = this
          timeoutID = setTimeout(() => {
            fn.apply(that, args)
            // fn(...args)
          }, delay);
        }
      }
    }

  }
</script>
<style lang="scss">

  .home-container {
    overflow-y: auto;
    max-height: 100%;

    .ais-logo {
      width: 165px;
    }


    .channels-list {
      white-space: nowrap;
      overflow-x: auto;

      .spacer {
        display: inline-block;
        margin: 35px 15px;
        background-color: #DDE4EF;
        height: 40px;
        width: 2px;
      }

      .channel-item {
        width: 90px;
        position: relative;
        display: inline-block;
        vertical-align: top;
        opacity: 0.5;

        a {
          text-transform: none;
          text-decoration: none;
          color: inherit;
        }

        &:not(:first-child):not(:last-child) {
          margin: 0 15px;
        }

        &:first-child {
          margin-right: 15px;
        }

        &:last-child {
          margin-left: 15px;
        }

        &:hover {
          cursor: pointer;
        }

        .poster-wrap {
          width: inherit;
          border-radius: 45px;

          .channel-poster {
            height: 100%;
            width: auto;
            max-width: 100%;
            object-fit: cover;
            border-radius: 8px;
          }
        }

        &.exclusive {

          //width: 90px;

          .poster-wrap {
            //border: 1px solid black;

            .channel-poster {
              //border-radius: 45px;
            }
          }
        }

        .channel-item-title {
          margin-top: 8px;
          font-size: 14px;
          line-height: 16px;
          opacity: 0.5;
          text-transform: uppercase;
          max-height: calc(34px + 1rem);
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          white-space: break-spaces;
          text-align: center;
        }

        .channel-item-epg {
          font-size: 15px;
          line-height: 18px;
          opacity: 0.5;
        }

        &.active {
          opacity: 1;

          .channel-item-title {
            font-weight: 600;
            opacity: 1;
          }

          .channel-item-epg {
            opacity: 1;
          }
        }

      }
    }

    .main-player {
      border-radius: 10px;
      margin: auto;
    }

    .channels-title {
      display: none;
      font-weight: 500;
      font-size: 15px;
      line-height: 18px;
    }

    @include media-breakpoint-down(lg) {

      .ais-logo {
        width: 120px;
      }
      .channels-list {
        .channel-item {
          width: 90px;
          //opacity: 1;

          .channel-item-title {
            //opacity: 1;
          }
        }
      }
      .channels-title {
        display: block;
      }
    }
    @include media-breakpoint-down(md) {

      .channels-list {
        .channel-item {
          width: 90px;


        }
      }

    }
    @include media-breakpoint-down(sm) {

      .channels-list {
        .channel-item {
          width: 90px;


        }
      }

    }
  }

</style>
